import styled from 'styled-components'
import { Color, MediaBreakpoint } from 'root-constants'

type TScaleValueContainerProps = {
  maxWidth: number
  bottomValue: number
}

type TScaleValueProps = {
  isActive: boolean
}

type TPointerProps = {
  rotationAngle: number
  left: number
  bottom: number
  minPhoneBottom: number
}

export const StyledStressScore = {
  Title: styled.h2`
    padding-bottom: 30px;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: ${Color.PRIMARY};
    text-align: center;
  `,
  ImageContainer: styled.div`
    position: relative;
  `,
  Text: styled.p`
    position: absolute;
    bottom: 40%;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 700;
    font-size: 24px;
    line-height: 33px;
    color: ${Color.WHITE};
    text-align: center;
  `,
  Scale: styled.img``,
  Pointer: styled.img<TPointerProps>`
    position: absolute;
    bottom: ${({ minPhoneBottom }) => `${minPhoneBottom}px`};
    left: ${({ left }) => `${left}%`};
    transform: ${({ rotationAngle }) =>
      `translateX(-50%) rotate(${rotationAngle}deg)`};
    max-width: 225px;

    @media (min-width: ${MediaBreakpoint.MIN_PHONE}px) {
      bottom: ${({ bottom }) => `${bottom}px`};
      max-width: 265px;
    }
  `,
  ScaleValueContainer: styled.div<TScaleValueContainerProps>`
    position: absolute;
    bottom: ${({ bottomValue }) => `${bottomValue}%`};
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-between;
    max-width: ${({ maxWidth }) => `${maxWidth}%`};
    width: 100%;
  `,
  ScaleValue: styled.span<TScaleValueProps>`
    min-width: 25px;
    font-weight: 600;
    font-size: 20px;
    line-height: 22px;
    color: ${({ isActive }) => (isActive ? Color.WHITE : '#898b95')};
    text-align: right;
  `,
}
